import { render, staticRenderFns } from "./TaskExercisesForm.vue?vue&type=template&id=0b6f02b6&lang=pug"
import script from "./TaskExercisesForm.vue?vue&type=script&lang=js"
export * from "./TaskExercisesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports